export const MAIN_NAVIGATION_TRANSLATION = {
  cat: 'Navegació principal del lloc web',
  de: 'Hauptnavigation der Website',
  en: 'Main site navigation',
  es: 'Navegación principal del sitio',
  fr: 'Navigation principale du site',
  it: 'Navigazione principale del sito',
  pt: 'Navegação principal do site',
}

export const SEARCHER_TRANSLATION = {
  cat: 'Cercador',
  de: 'Sucher',
  en: 'Searcher',
  es: 'Buscador',
  fr: 'Chercheur',
  it: 'Cercatore',
  pt: 'Buscador',
}

export const CATALOG_TRANSLATION_TRANSLATION = {
  cat: 'Catàleg',
  de: 'Katalog',
  en: 'Catalog',
  es: 'Catálogo',
  fr: 'Catalogue',
  it: 'Catalogo',
  pt: 'Catálogo',
}

export const CONTACT_INFORMATION_TRANSLATION = {
  cat: 'Informació de contacte',
  de: 'Kontaktinformationen',
  en: 'Contact information',
  es: 'Información de contacto',
  fr: 'Informations de contact',
  it: 'Informazioni di contatto',
  pt: 'Informações de contacto',
}

export const SOCIAL_NETWORKS_TRANSLATION = {
  cat: 'Xarxes socials',
  de: 'Soziale Netzwerke',
  en: 'Social networks',
  es: 'Redes sociales',
  fr: 'Réseaux sociaux',
  it: 'Reti sociali',
  pt: 'Redes sociais',
}
